// Mock data for Haarmony Interiors Landing Page

export const heroData = {
  title: "Transform Your Space Into Art",
  subtitle: "Where Design Meets Harmony",
  description: "Creating timeless interiors that reflect your personality and elevate your lifestyle",
  image: "https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzE2Nzg5MDV8MA&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "About Haarmony Interiors",
  description: "We are a Pune-based interior design studio dedicated to creating spaces that harmonize aesthetics with functionality. With years of experience and a passion for design excellence, we transform ordinary spaces into extraordinary environments that inspire and delight.",
  highlights: [
    { number: "50+", label: "Projects Completed" },
    { number: "40+", label: "Happy Clients" },
    { number: "20+", label: "Years Experience" },
    { number: "100%", label: "Satisfaction Rate" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Residential Design",
    description: "From cozy apartments to luxurious villas, we create personalized living spaces that reflect your lifestyle and taste.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzE2Nzg5MDV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Commercial Design",
    description: "Transform your workspace into a productive and inspiring environment that enhances your brand identity.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Consultation Services",
    description: "Expert design advice and guidance to help you make informed decisions about your interior design project.",
    icon: "MessageSquare",
    image: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Full-Service Design & Execution",
    description: "End-to-end design and execution services, from concept to completion, ensuring a seamless experience.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzE2Nzg5MDV8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "Modern Living Room",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzE2Nzg5MDV8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Contemporary Bedroom",
    category: "Residential",
    image: "https://images.pexels.com/photos/3754595/pexels-photo-3754595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Executive Office",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Conference Room",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Collaborative Workspace",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1587702068694-a909ef4aa346?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Open Office Design",
    category: "Commercial",
    image: "https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Homeowner",
    content: "Haarmony Interiors transformed our apartment into a beautiful, functional space. Their attention to detail and understanding of our needs was exceptional!",
    rating: 5
  },
  {
    id: 2,
    name: "Rajesh Patil",
    role: "Business Owner",
    content: "Our office redesign exceeded all expectations. The team created a workspace that's both professional and inspiring. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Sneha Deshmukh",
    role: "Interior Design Enthusiast",
    content: "Working with Haarmony was a delightful experience. They listened to our vision and brought it to life beautifully. The result is stunning!",
    rating: 5
  }
];

export const contactData = {
  email: "sudhir@haarmonyinteriors.com",
  phone: "+91 9511975166",
  address: "1578, Anurag Apt., Shurkrwar Peth, Pune - 411003",
  instagram: "haarmony_interiors",
  instagramQR: "https://api.qrserver.com/v1/create-qr-code/?data=https://Instagram.com/haarmony_interiors&size=200x200",
  website: "https://haarmonyinteriors.com/"
};

export const businessHours = {
  weekdays: "Monday - Saturday: 10:00 AM - 7:00 PM",
  sunday: "Sunday: Closed",
  note: "Available for consultations by appointment"
};

export const whatsappMessages = {
  general: "Hi! I found your interior design services and would like to discuss a project.",
  residential: "Hi! I'm interested in residential interior design services. Can we discuss my requirements?",
  commercial: "Hi! I'd like to inquire about commercial interior design for my business space.",
  consultation: "Hi! I'm interested in booking a design consultation. What are the next steps?",
  portfolio: "Hi! I saw your portfolio and I'm impressed. I'd like to discuss a similar project for my space.",
  quote: "Hi! I'd like to get a free quote for my interior design project. Can we discuss?"
};

// Room Categories for Portfolio
export const roomCategories = [
  { id: 'all', name: 'All Projects', icon: 'LayoutGrid' },
  { id: 'living', name: 'Living Room', icon: 'Sofa' },
  { id: 'bedroom', name: 'Bedroom', icon: 'Bed' },
  { id: 'kitchen', name: 'Kitchen', icon: 'ChefHat' },
  { id: 'bathroom', name: 'Bathroom', icon: 'Bath' },
  { id: 'office', name: 'Office', icon: 'Briefcase' },
  { id: 'commercial', name: 'Commercial', icon: 'Building2' }
];

// Enhanced Portfolio with room categories
export const portfolioProjects = [
  {
    id: 1,
    title: "Modern Minimalist Living Room",
    category: "living",
    style: "Modern",
    area: "250 sq ft",
    budget: "₹2.5L - ₹3.5L",
    duration: "45 days",
    image: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3NzE2Nzg5MDV8MA&ixlib=rb-4.1.0&q=85",
    beforeImage: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80",
    features: ["Smart TV Unit", "Hidden Storage", "Ambient Lighting", "Modular Sofa"]
  },
  {
    id: 2,
    title: "Contemporary Master Bedroom",
    category: "bedroom",
    style: "Contemporary",
    area: "180 sq ft",
    budget: "₹1.8L - ₹2.5L",
    duration: "30 days",
    image: "https://images.pexels.com/photos/3754595/pexels-photo-3754595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    beforeImage: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800&q=80",
    features: ["Walk-in Wardrobe", "Study Corner", "False Ceiling", "Premium Bedding"]
  },
  {
    id: 3,
    title: "Executive Office Space",
    category: "office",
    style: "Professional",
    area: "300 sq ft",
    budget: "₹3L - ₹4L",
    duration: "40 days",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85",
    beforeImage: "https://images.unsplash.com/photo-1497366858526-0766cadbe8fa?w=800&q=80",
    features: ["Ergonomic Furniture", "Cable Management", "Meeting Area", "Storage Solutions"]
  },
  {
    id: 4,
    title: "Modular Kitchen Design",
    category: "kitchen",
    style: "Modern",
    area: "120 sq ft",
    budget: "₹2L - ₹3L",
    duration: "35 days",
    image: "https://images.unsplash.com/photo-1556912173-3bb406ef7e77?w=800&q=80",
    beforeImage: "https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=800&q=80",
    features: ["Modular Cabinets", "Granite Countertop", "Chimney & Hob", "Pull-out Drawers"]
  },
  {
    id: 5,
    title: "Luxury Bathroom Design",
    category: "bathroom",
    style: "Luxury",
    area: "80 sq ft",
    budget: "₹1.5L - ₹2L",
    duration: "25 days",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80",
    beforeImage: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&q=80",
    features: ["Premium Fittings", "Glass Partition", "Storage Cabinets", "Modern Fixtures"]
  },
  {
    id: 6,
    title: "Restaurant Interior",
    category: "commercial",
    style: "Industrial",
    area: "800 sq ft",
    budget: "₹8L - ₹12L",
    duration: "60 days",
    image: "https://images.unsplash.com/photo-1587702068694-a909ef4aa346?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzE2Nzg5MTB8MA&ixlib=rb-4.1.0&q=85",
    beforeImage: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80",
    features: ["Seating for 40", "Bar Counter", "Kitchen Setup", "Ambient Lighting"]
  }
];

// Design Styles for Quiz
export const designStyles = [
  { 
    id: 'modern', 
    name: 'Modern Minimalist',
    description: 'Clean lines, neutral colors, minimal decor',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=400&q=80'
  },
  { 
    id: 'contemporary', 
    name: 'Contemporary',
    description: 'Current trends, bold accents, mixed materials',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&q=80'
  },
  { 
    id: 'traditional', 
    name: 'Traditional Indian',
    description: 'Rich colors, ornate details, cultural elements',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=400&q=80'
  },
  { 
    id: 'industrial', 
    name: 'Industrial',
    description: 'Exposed brick, metal accents, raw textures',
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=400&q=80'
  }
];

// FAQs
export const faqs = [
  {
    question: "What services does Haarmony Interiors offer?",
    answer: "We offer complete interior design services including residential design, commercial spaces, consultation services, and full-service design & execution from concept to completion."
  },
  {
    question: "How much does interior design cost in Pune?",
    answer: "Our projects typically range from ₹1.5L to ₹12L+ depending on the space size, materials, and customization. We offer free consultations and detailed quotes tailored to your budget."
  },
  {
    question: "What is the typical project timeline?",
    answer: "Most residential projects take 25-45 days, while commercial projects take 45-60 days. The timeline depends on project scope, approvals, and material availability."
  },
  {
    question: "Do you provide 3D visualizations?",
    answer: "Yes! We provide detailed 3D renders and walkthroughs so you can visualize your space before execution begins."
  },
  {
    question: "What areas in Pune do you serve?",
    answer: "We serve all areas of Pune including Shurkrwar Peth, Kothrud, Baner, Wakad, Viman Nagar, Koregaon Park, and surrounding regions."
  },
  {
    question: "Do you offer warranty on your work?",
    answer: "Yes, we provide warranty on materials and workmanship. Terms vary by project - we'll discuss details during consultation."
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=500&q=80",
    likes: 245,
    caption: "Modern minimalist living room design ✨"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=500&q=80",
    likes: 189,
    caption: "Elegant bedroom transformation 🛏️"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=500&q=80",
    likes: 312,
    caption: "Contemporary kitchen design 🍳"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=500&q=80",
    likes: 276,
    caption: "Cozy reading nook inspiration 📚"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=500&q=80",
    likes: 198,
    caption: "Luxury bathroom design 🛁"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=500&q=80",
    likes: 234,
    caption: "Dining area perfection 🍽️"
  }
];

export const logoUrl = "data:image/svg+xml,%3Csvg width='400' height='160' viewBox='0 0 400 160' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='400' height='160' fill='%23000000'/%3E%3Cg transform='translate(20, 18)'%3E%3Ccircle cx='50' cy='50' r='44' stroke='%23FFFFFF' stroke-width='6' fill='none'/%3E%3Cpath d='M30 50 L45 30 L60 50 L45 70 Z' fill='%23FFFFFF'/%3E%3Cpath d='M93 18 H152 V28 H93 Z' fill='%23FFFFFF'/%3E%3Ctext x='0' y='120' fill='%23FFFFFF' font-family='Inter, Arial, sans-serif' font-size='34' font-weight='700'%3EHAARMONY%3C/text%3E%3Ctext x='0' y='150' fill='%23FFFFFF' font-family='Inter, Arial, sans-serif' font-size='18' letter-spacing='1'%3EINTERIORS%3C/text%3E%3C/g%3E%3C/svg%3E";
export const videoUrl = "https://www.w3schools.com/html/mov_bbb.mp4";
